import type { BackendRouteDefinition } from '../types';

// Keep the callable wrapper signature unchanged while moving matterId into the
// HTTP path so this work block only touches its owned route-definition module.
export const setDefaultPaymentInstrumentIdForMatterRoute = {
  transport: 'api',
  method: 'POST',
  path: '/clients/matters/:matterId/default-payment-instrument',
  params: ({ matterId }: { matterId: string }) => ({
    matterId,
  }),
  body: ({
    paymentInstrumentId,
    environment,
  }: {
    paymentInstrumentId: string;
    environment: 'sandbox' | 'live';
  }) => ({
    paymentInstrumentId,
    environment,
  }),
} as const satisfies BackendRouteDefinition;
